export const SALES_CHANNEL_CONFIG = {
  REPORTABLE: 5,
  ACTIVE: 6
}
